import { Route } from "react-router-dom";
import { PreserveState } from "src/components/Navigation/PreserveState";
import { RequireUserPermissions } from "src/components/Permissions/RequireUserPermissions";
import { Organizations } from "src/services/url/Admin";
import { Index } from ".";
import { New } from "./New";

export const AdminOrganizationsRoutes = (
  <Route
    path={Organizations.indexPath}
    element={
      <PreserveState>
        <RequireUserPermissions permission="navigation.admin.organizations">
          <Index />
        </RequireUserPermissions>
      </PreserveState>
    }
  >
    <Route
      path={Organizations.newPath}
      element={
        <RequireUserPermissions permission="organization:create">
          <New />
        </RequireUserPermissions>
      }
    />
  </Route>
);
